import { useQuery } from 'react-query'
import axios from 'axios'

const endpoint = '/api/permissions'

export function usePermissions() {
  const {
    isLoading,
    data: response = {},
    refetch,
  } = useQuery({
    queryKey: [endpoint],
    queryFn: () => axios.get(endpoint),
  })

  const createPermission = async (values) => {
    await axios.post(endpoint, values)
    refetch()
  }

  const deletePermission = async (id) => {
    await axios.delete(`${endpoint}/${id}`)
    refetch()
  }

  const updatePermission = async (values) => {
    await axios.put(`${endpoint}/${values._id}`, values)
    refetch()
  }

  const { data = [] } = response

  return {
    isLoading,
    data,
    createPermission,
    deletePermission,
    updatePermission,
  }
}
